import React, { Component } from "react";
import { connect } from "react-redux";

import { submitSSWP, getSSWPMasterConfigs, deleteSSWPConfig } from "./actions";

import {
    selectSSWPConfigs,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
} from "./selectors";
import images from "./hazard_control_images_and_descriptors.js";
import structure from "./sswp_form_keys_upload_structure.json";
import infoOrange from "./img/sswpIcons/info-24.png";
import infoRed from "./img/sswpIcons/info-24red.png";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { hot } from "react-hot-loader";

import {
    Stepper,
    Step,
    StepLabel,
    FormControlLabel,
    ListItemSecondaryAction,
    Paper,
    Typography,
    Switch,
    Collapse,
    ListItemText,
    TextField,
    Select,
    MenuItem,
    FormControl,
    Button,
    Radio,
    RadioGroup,
    Grid,
    List,
    ListItem,
    ExpansionPanel,
    IconButton,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from "@material-ui/core";
import styled from "styled-components";

import InfoModal from "./InfoModal";
import {
    ExpandMore as ExpandMoreIcon,
    Done as CheckedIcon,
    Delete as DeleteIcon,
} from "@material-ui/icons";
var arr = [];
const SelectYesNoDiv = styled.div`
    display: inline-flex;
    padding-left: 10px;
    border: 1px solid #e0e0e0;
    width: inherit;
    height: 8vh;
`;
const SelectYesNoSwitch = styled(Switch)`
    float: right;
    margin-top: auto;
    margin-bottom: auto;
`;

const HazardInfo = styled(Paper)`
    width: 100%;
    height: fit-content;

    position: relative;
    border: 1px solid lightgray;
`;
const HazardInfoIcon = styled.img`
    position: absolute;
    right: 0;
    zindex: 1;
    margin-top: -14px;
    margin-right: -10px;
`;
const HazardImg = styled.img`
    display: block;
    height: 20vh;
    margin-left: auto;
    margin-right: auto;
`;
const HazardText = styled.div`
    text-align: center;
    height: 7vh;
`;

const ControlImg = styled.img`
    height: 17vh;
    display: block;
    margin-left: auto;
    margin-right: auto;
`;
const ControlTextDiv = styled.div`
    text-align: center;
    height: 6.7vh;
    border: 1px solid #e0e0e0;
    line-height: 6.7vh;
`;
const ControlPaper = styled(Paper)`
    position: relative;
`;
const ControlInfoIconIgm = styled.img`
    position: absolute;
    right: -5px;
    z-index: 1;
`;

const HazardGridItemImg = styled.img`
    width: 80%;
    height: 80%;
    margin: 10%;
`;
const HazardGridSelectYesNoSwitch = styled.div`
    display: inline-flex;
    padding-left: 10px;
    border: 1px solid #e0e0e0;
    width: -webkit-fill-available;
    height: 8vh;
`;

class MasterSSWPFormCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            structure: structure,
            images: images,
            hazardsModal: false,
            formName: "",
            editFormIndex: "",
            editingForm: false,
            formUID: false,
            allHazardsSelected: true,
            infoModal: false,
            activeStep: 0,
            expanded: false,
            infoModalTextImg: {
                img: "",
                text: "",
            },
            templateType: "new",
            stepLabels: [
                "New/Edit SSWP Template Selection",
                "Select Hazards",
                "Select Controls",
                "Review Selection",
            ],
            warningModal: false,
            deleteModal: false,
        };
        props.getSSWPMasterConfigs();
    }

    renderControl(hazard, control) {
        const struct = this.state.structure;

        return (
            <Grid
                item
                xs={6}
                sm={6}
                md={3}
                lg={2}
                xl={2}
                key={control[0]}
                style={{ position: "relative" }}
            >
                <ControlInfoIconIgm
                    src={control[1].text === "" ? infoRed : infoOrange}
                    style={{ cursor: "pointer" }}
                    alt="Control"
                    onClick={() => {
                        this.setState({
                            infoModal: true,
                            infoModalTextImg: {
                                img: control[1].icon,
                                text: control[1].text,
                            },
                        });
                    }}
                />
                <ControlPaper>
                    <div style={{}}>
                        <div>
                            <ControlImg
                                src={control[1].icon}
                                alt={control[1].name}
                            />
                            <ControlTextDiv>
                                <Typography
                                    style={{
                                        margin: "auto",
                                    }}
                                    variant="body2"
                                >
                                    {control[1].name}
                                </Typography>
                            </ControlTextDiv>
                        </div>
                        <Collapse in={struct[hazard].selected}>
                            <SelectYesNoDiv>
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    De/Select All Controls
                                </Typography>
                                <SelectYesNoSwitch
                                    checked={
                                        struct[hazard].low[control[0]] &&
                                        struct[hazard].med[control[0]] &&
                                        struct[hazard].high[control[0]]
                                    }
                                    value={control[1].name}
                                    onChange={(event) => {
                                        let updateStruct = struct;
                                        updateStruct[hazard].low[control[0]] =
                                            event.target.checked;
                                        updateStruct[hazard].med[control[0]] =
                                            event.target.checked;
                                        updateStruct[hazard].high[control[0]] =
                                            event.target.checked;
                                        this.setState({
                                            structure: updateStruct,
                                        });
                                    }}
                                    disabled={
                                        struct[hazard].selected_low === false ||
                                        struct[hazard].selected_med === false ||
                                        struct[hazard].selected_high === false
                                            ? true
                                            : false
                                    }
                                />
                            </SelectYesNoDiv>
                            <SelectYesNoDiv
                                style={{
                                    backgroundColor: "#C8E6C9",
                                }}
                            >
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    Low
                                </Typography>
                                <SelectYesNoSwitch
                                    checked={struct[hazard].low[control[0]]}
                                    value={control[1].name}
                                    onChange={(event) => {
                                        let updateStruct = struct;
                                        updateStruct[hazard].low[control[0]] =
                                            event.target.checked;
                                        this.setState({
                                            structure: updateStruct,
                                        });
                                    }}
                                    disabled={
                                        struct[hazard].selected_low === false
                                            ? true
                                            : false
                                    }
                                />
                            </SelectYesNoDiv>
                            <SelectYesNoDiv
                                style={{
                                    backgroundColor: "#FFF59D",
                                }}
                            >
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    Medium
                                </Typography>
                                <SelectYesNoSwitch
                                    checked={struct[hazard].med[control[0]]}
                                    value={control[1].name}
                                    onChange={(event) => {
                                        let updateStruct = struct;
                                        updateStruct[hazard].med[control[0]] =
                                            event.target.checked;
                                        this.setState({
                                            structure: updateStruct,
                                        });
                                    }}
                                    disabled={
                                        struct[hazard].selected_med === false
                                            ? true
                                            : false
                                    }
                                />
                            </SelectYesNoDiv>
                            <SelectYesNoDiv
                                style={{
                                    background: "#FFAB91",
                                    pointerEvents:
                                        struct[hazard].selected_high === false
                                            ? "none"
                                            : "auto",
                                }}
                            >
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    High
                                </Typography>
                                <SelectYesNoSwitch
                                    checked={struct[hazard].high[control[0]]}
                                    value={control[1].name}
                                    onChange={(event) => {
                                        let updateStruct = struct;
                                        updateStruct[hazard].high[control[0]] =
                                            event.target.checked;
                                        this.setState({
                                            structure: updateStruct,
                                        });
                                    }}
                                    disabled={
                                        struct[hazard].selected_high === false
                                            ? true
                                            : false
                                    }
                                />
                            </SelectYesNoDiv>
                        </Collapse>
                    </div>
                </ControlPaper>
            </Grid>
        );
    }
    renderHazard(hazard) {
        const struct = this.state.structure;
        return (
            <React.Fragment>
                <Grid container spacing={4}>
                    <Grid item lg={2} md={2} sm={12} key={hazard[0]}>
                        <HazardInfo elevation={4}>
                            <HazardInfoIcon
                                src={
                                    hazard[1].text === "" ? infoRed : infoOrange
                                }
                                alt="Hazard"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    this.setState({
                                        infoModal: true,
                                        infoModalTextImg: {
                                            img: hazard[1].icon,
                                            text: hazard[1].text,
                                        },
                                    });
                                }}
                            />
                            <HazardImg
                                src={hazard[1].icon}
                                alt={hazard[1].name}
                            />
                            <HazardText>
                                <Typography variant="subtitle2">
                                    {hazard[1].name}
                                </Typography>
                            </HazardText>

                            <Collapse in={struct[hazard[0]].selected}>
                                <SelectYesNoDiv
                                    style={{ backgroundColor: "#C8E6C9" }}
                                >
                                    <Typography
                                        style={{
                                            margin: "auto",
                                            float: "left",
                                        }}
                                        variant="subtitle2"
                                    >
                                        Low
                                    </Typography>
                                    <SelectYesNoSwitch
                                        checked={struct[hazard[0]].selected_low}
                                        value={hazard[0]}
                                        onChange={(event) => {
                                            let updateStruct = struct;
                                            updateStruct[
                                                hazard[0]
                                            ].selected_low =
                                                event.target.checked;

                                            if (
                                                event.target.checked === false
                                            ) {
                                                Object.keys(
                                                    updateStruct[hazard[0]].low
                                                ).map((e) => {
                                                    updateStruct[hazard[0]].low[
                                                        e
                                                    ] = false;
                                                    return null;
                                                });
                                            }
                                            this.setState({
                                                structure: updateStruct,
                                            });
                                        }}
                                    />
                                </SelectYesNoDiv>
                                <SelectYesNoDiv
                                    style={{ backgroundColor: "#FFF59D" }}
                                >
                                    <Typography
                                        style={{
                                            margin: "auto",
                                            float: "left",
                                        }}
                                        variant="subtitle2"
                                    >
                                        Medium
                                    </Typography>
                                    <SelectYesNoSwitch
                                        checked={struct[hazard[0]].selected_med}
                                        value={hazard[0]}
                                        onChange={(event) => {
                                            let updateStruct = struct;
                                            updateStruct[
                                                hazard[0]
                                            ].selected_med =
                                                event.target.checked;

                                            if (
                                                event.target.checked === false
                                            ) {
                                                Object.keys(
                                                    updateStruct[hazard[0]].med
                                                ).map((e) => {
                                                    updateStruct[hazard[0]].med[
                                                        e
                                                    ] = false;
                                                    return null;
                                                });
                                            }
                                            this.setState({
                                                structure: updateStruct,
                                            });
                                        }}
                                    />
                                </SelectYesNoDiv>
                                <SelectYesNoDiv
                                    style={{ backgroundColor: "#FFAB91" }}
                                >
                                    <Typography
                                        style={{
                                            margin: "auto",
                                            float: "left",
                                        }}
                                        variant="subtitle2"
                                    >
                                        High
                                    </Typography>
                                    <SelectYesNoSwitch
                                        checked={
                                            struct[hazard[0]].selected_high
                                        }
                                        value={hazard[0]}
                                        onChange={(event) => {
                                            let updateStruct = struct;
                                            updateStruct[
                                                hazard[0]
                                            ].selected_high =
                                                event.target.checked;

                                            if (
                                                event.target.checked === false
                                            ) {
                                                Object.keys(
                                                    updateStruct[hazard[0]].high
                                                ).map((e) => {
                                                    updateStruct[
                                                        hazard[0]
                                                    ].high[e] = false;
                                                    return null;
                                                });
                                            }
                                            this.setState({
                                                structure: updateStruct,
                                            });
                                        }}
                                    />
                                </SelectYesNoDiv>
                            </Collapse>
                        </HazardInfo>
                    </Grid>
                    <Grid item lg={10} md={10} sm={12}>
                        <Grid container spacing={4}>
                            {struct[hazard[0]].selected &&
                                Object.entries(hazard[1].icons).map((e) => {
                                    return this.renderControl(hazard[0], e);
                                })}
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
    renderHazardGridItem(hazard, info) {
        let struct = this.state.structure;
        if (!struct[hazard]) {
            struct[hazard] = structure[hazard];
            this.setState({ structure: struct });
        }
        if (struct)
            return (
                <Grid item xs={6} sm={6} md={4} lg={2} xl={2} key={hazard}>
                    <Paper style={{ border: "1px solid black" }}>
                        <HazardGridItemImg src={info.icon} alt={hazard} />
                        <HazardText variant="body2">{info.name}</HazardText>
                        <HazardGridSelectYesNoSwitch>
                            <Typography
                                style={{ margin: "auto", float: "left" }}
                                variant="subtitle2"
                            >
                                De/Select
                            </Typography>
                            {struct[hazard] && (
                                <SelectYesNoSwitch
                                    checked={
                                        struct[hazard].selected_na === true
                                            ? true
                                            : false
                                    }
                                    value={hazard}
                                    onChange={(event) => {
                                        let updateStruct = struct;
                                        updateStruct[hazard].selected_na =
                                            event.target.checked === true
                                                ? true
                                                : false;
                                        this.setState({
                                            structure: updateStruct,
                                        });
                                    }}
                                />
                            )}
                        </HazardGridSelectYesNoSwitch>
                    </Paper>
                </Grid>
            );
    }
    getNameStep = () => {
        const { templateType } = this.state;
        return (
            <>
                <Grid container spacing={4}>
                    <Grid item sm={12} md={6} lg={6} xl={6}>
                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label="template"
                                name="templateType"
                                value={templateType}
                                onChange={(event) => {
                                    this.setState({
                                        templateType: event.target.value,
                                    });
                                    if (event.target.value === "new") {
                                        this.setState({
                                            editingForm: false,
                                            editFormIndex: -1,
                                            structure: structure,
                                            formName: "",
                                            formUID: false,
                                        });
                                    }
                                }}
                            >
                                <FormControlLabel
                                    value="new"
                                    control={<Radio />}
                                    label="New Template"
                                />
                                <FormControlLabel
                                    value="edit"
                                    control={<Radio />}
                                    label="Edit Template"
                                />
                                <FormControlLabel
                                    value="copy"
                                    control={<Radio />}
                                    label="Copy Template"
                                />
                            </RadioGroup>
                        </FormControl>
                        {templateType === "new" ? (
                            <>
                                <Typography>
                                    <b>Please Enter Form Name: </b>
                                </Typography>

                                <TextField
                                    style={{
                                        minWidth: "300px",
                                    }}
                                    value={this.state.formName}
                                    onChange={(event) => {
                                        this.setState({
                                            formName: event.target.value,
                                        });
                                        if (
                                            arr.includes(event.target.value) ===
                                            true
                                        ) {
                                            this.setState({
                                                warningModal: true,
                                            });
                                        }
                                    }}
                                />
                            </>
                        ) : templateType === "copy" ? (
                            <>
                                <Typography>
                                    <b>Select Existing SSWP: </b>
                                </Typography>
                                <FormControl
                                    style={{
                                        minWidth: "250px",
                                    }}
                                >
                                    <Select
                                        value={this.state.editFormIndex}
                                        onChange={(event) => {
                                            let selectedConfig = this.props
                                                .sswpConfigs[
                                                event.target.value
                                            ];

                                            this.setState({
                                                editFormIndex:
                                                    event.target.value,
                                                structure: selectedConfig,
                                            });
                                        }}
                                    >
                                        {this.props.canUpdate &&
                                            Object.keys(
                                                this.props.sswpConfigs
                                            ).map((e, i) => {
                                                return (
                                                    <MenuItem value={e} key={i}>
                                                        {
                                                            this.props
                                                                .sswpConfigs[e]
                                                                .template_name
                                                        }
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </FormControl>
                                <Typography>
                                    <b>Please Enter New Form Name: </b>
                                </Typography>

                                <TextField
                                    style={{
                                        minWidth: "300px",
                                    }}
                                    value={this.state.formName}
                                    onChange={(event) => {
                                        this.setState({
                                            formName: event.target.value,
                                        });
                                        if (
                                            arr.includes(event.target.value) ===
                                            true
                                        ) {
                                            this.setState({
                                                warningModal: true,
                                            });
                                        }
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <Typography>
                                    <b>Select Existing SSWP: </b>
                                </Typography>
                                <FormControl
                                    style={{
                                        minWidth: "250px",
                                    }}
                                >
                                    <Select
                                        value={this.state.editFormIndex}
                                        onChange={(event) => {
                                            let selectedConfig = this.props
                                                .sswpConfigs[
                                                event.target.value
                                            ];

                                            this.setState({
                                                editingForm: true,
                                                editFormIndex:
                                                    event.target.value,
                                                structure: selectedConfig,
                                                formName:
                                                    selectedConfig.template_name,

                                                formUID: event.target.value,
                                            });
                                        }}
                                    >
                                        {this.props.canUpdate &&
                                            Object.keys(
                                                this.props.sswpConfigs
                                            ).map((e, i) => {
                                                return (
                                                    <MenuItem value={e} key={i}>
                                                        {
                                                            this.props
                                                                .sswpConfigs[e]
                                                                .template_name
                                                        }
                                                    </MenuItem>
                                                );
                                            })}
                                    </Select>
                                </FormControl>
                            </>
                        )}
                    </Grid>

                    <Grid item sm={12} md={6} lg={6} xl={6}>
                        <Typography>
                            <b>Existing SSWP Templates </b>
                        </Typography>
                        <List style={{ height: "50vh", overflowY: "scroll" }}>
                            {this.props.sswpConfigs &&
                                Object.keys(this.props.sswpConfigs).map(
                                    (e, i) => {
                                        return (
                                            <ListItem value={e} key={i}>
                                                <ListItemText
                                                    primary={
                                                        this.props.sswpConfigs[
                                                            e
                                                        ].template_name
                                                    }
                                                />
                                                <ListItemSecondaryAction>
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="delete"
                                                        onClick={() => {
                                                            this.setState({
                                                                deleteModal: e,
                                                            });
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        );
                                    }
                                )}
                        </List>
                    </Grid>
                </Grid>{" "}
            </>
        );
    };
    getHazardsStep = () => {
        return (
            <>
                <Typography
                    style={{
                        width: "100%",
                        marginTop: "10px",
                        marginBottom: "10px",
                        textAlign: "center",
                    }}
                    variant="title"
                >
                    Please Select Hazards To Include In SSWP
                </Typography>
                <Paper
                    style={{
                        display: "inline-flex",
                        marginLeft: "12px",
                        marginBottom: "10px",
                    }}
                >
                    <Typography
                        variant="subtitle2"
                        style={{
                            marginTop: "12px",
                            marginLeft: "4px",
                        }}
                    >
                        De/Select All Hazards
                    </Typography>
                    <Switch
                        checked={this.state.allHazardsSelected}
                        onChange={(event) => {
                            let updateStruct = this.state.structure;
                            Object.keys(updateStruct).map((e) => {
                                if (e === "template_name") {
                                    return null;
                                } else {
                                    updateStruct[e].selected_na =
                                        event.target.checked;
                                }

                                return true;
                            });
                            this.setState({
                                structure: updateStruct,
                                allHazardsSelected: event.target.checked,
                            });
                        }}
                    />
                </Paper>
                <Grid container spacing={4}>
                    {Object.keys(images).map((e) => {
                        return this.renderHazardGridItem(e, images[e]);
                    })}
                </Grid>
            </>
        );
    };
    scrollTo = (id) => {
        let elem = document.getElementById(id);

        window.scrollTo({
            top: elem.getBoundingClientRect().top + 100,
            behavior: "smooth",
        });
    };
    getControlStep = () => {
        return (
            images &&
            Object.entries(images).map((e) => {
                if (!this.state.structure[e[0]]) {
                    let struct = this.state.structure;
                    struct[e[0]] = structure[e[0]];
                    this.setState({ structure: struct });
                }
                if (this.state.structure[e[0]])
                    if (this.state.structure[e[0]].selected_na === true) {
                        return (
                            <ExpansionPanel
                                id={"pan_" + e[1].name}
                                expanded={this.state.expanded === e[1].name}
                                onChange={(event, expanded) => {
                                    let updateStruct = this.state.structure;
                                    updateStruct[e[0]].selected = expanded;
                                    updateStruct[e[0]].selected_low = true;
                                    updateStruct[e[0]].selected_med = true;
                                    updateStruct[e[0]].selected_high = true;
                                    this.setState({
                                        structure: updateStruct,
                                    });
                                    this.setState({
                                        expanded: expanded ? e[1].name : false,
                                    });

                                    this.scrollTo("pan_" + e[1].name);
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <img
                                        src={e[1].icon || ""}
                                        alt={e[1].icon}
                                        style={{ height: 50, width: "auto" }}
                                    />
                                    <Typography style={{ marginTop: 4 }}>
                                        {e[1].name}
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    {this.renderHazard(e)}
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        );
                    } else return null;
                return null;
            })
        );
    };
    renderReviewControls(hazard, control) {
        const struct = this.state.structure;
        if (
            struct[hazard].high[control[0]] ||
            struct[hazard].med[control[0]] ||
            struct[hazard].low[control[0]]
        )
            return (
                <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={2}
                    xl={2}
                    key={control[0]}
                    style={{ position: "relative" }}
                >
                    <ControlInfoIconIgm
                        src={control[1].text === "" ? infoRed : infoOrange}
                        style={{ cursor: "pointer" }}
                        alt="Control"
                        onClick={() => {
                            this.setState({
                                infoModal: true,
                                infoModalTextImg: {
                                    img: control[1].icon,
                                    text: control[1].text,
                                },
                            });
                        }}
                    />
                    <ControlPaper>
                        <div>
                            <ControlImg
                                src={control[1].icon}
                                alt={control[1].name}
                            />
                            <ControlTextDiv>
                                <Typography
                                    style={{
                                        margin: "auto",
                                    }}
                                    variant="body2"
                                >
                                    {control[1].name}
                                </Typography>
                            </ControlTextDiv>
                        </div>
                        <div>
                            <SelectYesNoDiv style={{ width: "100%" }}>
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    Low{" "}
                                    {struct[hazard].low[control[0]] && (
                                        <CheckedIcon
                                            style={{ color: "green" }}
                                        />
                                    )}
                                </Typography>
                            </SelectYesNoDiv>
                            <SelectYesNoDiv style={{ width: "100%" }}>
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    Medium{" "}
                                    {struct[hazard].med[control[0]] && (
                                        <CheckedIcon
                                            style={{ color: "green" }}
                                        />
                                    )}
                                </Typography>
                            </SelectYesNoDiv>
                            <SelectYesNoDiv style={{ width: "100%" }}>
                                <Typography
                                    style={{
                                        margin: "auto",
                                        float: "left",
                                    }}
                                    variant="subtitle2"
                                >
                                    High{" "}
                                    {struct[hazard].high[control[0]] && (
                                        <CheckedIcon
                                            style={{ color: "green" }}
                                        />
                                    )}
                                </Typography>
                            </SelectYesNoDiv>
                        </div>
                    </ControlPaper>
                </Grid>
            );
        else return null;
    }
    getReviewStep = () => {
        const struct = this.state.structure;
        return (
            images &&
            Object.entries(images).map((e) => {
                if (this.state.structure[e[0]])
                    if (this.state.structure[e[0]].selected_na === true) {
                        return (
                            <ExpansionPanel expanded={true}>
                                <ExpansionPanelSummary
                                    style={{ width: "100%" }}
                                >
                                    <img
                                        src={e[1].icon || ""}
                                        alt={e[1].icon}
                                        style={{ height: 50, width: "auto" }}
                                    />
                                    <div style={{ float: "right" }}>
                                        <Typography
                                            style={{
                                                marginTop: 6,
                                                marginLeft: 6,
                                            }}
                                        >
                                            <b>{e[1].name}</b>
                                        </Typography>
                                        <br />
                                        <Typography
                                            style={{
                                                display: "inline",
                                                marginTop: 24,
                                                marginRight: 6,
                                            }}
                                        >
                                            High{" "}
                                            {struct[e[0]].selected_high && (
                                                <CheckedIcon
                                                    style={{ color: "green" }}
                                                />
                                            )}
                                        </Typography>
                                        <Typography
                                            style={{
                                                display: "inline",
                                                marginTop: 6,
                                                marginRight: 6,
                                            }}
                                        >
                                            Medium{" "}
                                            {struct[e[0]].selected_med && (
                                                <CheckedIcon
                                                    style={{ color: "green" }}
                                                />
                                            )}
                                        </Typography>
                                        <Typography
                                            style={{
                                                display: "inline",
                                                marginTop: 6,
                                                marginRight: 6,
                                            }}
                                        >
                                            Low{" "}
                                            {struct[e[0]].selected_low && (
                                                <CheckedIcon
                                                    style={{ color: "green" }}
                                                />
                                            )}
                                        </Typography>
                                    </div>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Grid container spacing={4}>
                                        {Object.entries(e[1].icons).map((f) => {
                                            return this.renderReviewControls(
                                                e[0],
                                                f
                                            );
                                        })}
                                    </Grid>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        );
                    } else return null;
                return null;
            })
        );
    };
    getStepContent = (step) => {
        switch (step) {
            case 0:
                return this.getNameStep();
            case 1:
                return this.getHazardsStep();
            case 2:
                return this.getControlStep();
            case 3:
                return this.getReviewStep();
            case 4:
                return "You have completed a new SSWP Template!";
            default:
                return "Unknown step";
        }
    };
    getCurrentStatus = () => {
        let type = this.state.templateType;
        if (type === "new") {
            return (
                "Creating a new Template with the name '" +
                this.state.formName +
                "'"
            );
        } else if (type === "edit")
            return (
                "Editing a template with the name '" + this.state.formName + "'"
            );
        else
            return (
                "Copying " +
                ("'" + this.state.structure.template_name + "'" ||
                    "a template") +
                " with a new name '" +
                this.state.formName +
                "'"
            );
    };
    render() {
        const { stepLabels, activeStep } = this.state;
        Object.values(this.props.sswpConfigs).map((e) => {
            return arr.push(e.template_name);
        });
        return (
            <StyledCard>
                <>
                    <StyledHeader>
                        <Typography variant="h5">
                            SSWP Template Wizard - {this.getCurrentStatus()}
                        </Typography>
                    </StyledHeader>
                    <StyledContent style={{ padding: 20 }}>
                        <StyledViewContainer>
                            <Grid container>
                                <Grid item xl={2} lg={2} md={2} sm={12}>
                                    <Stepper
                                        activeStep={activeStep}
                                        orientation="vertical"
                                    >
                                        {stepLabels.map((label, index) => {
                                            return (
                                                <Step key={label}>
                                                    <StepLabel>
                                                        {label}
                                                    </StepLabel>
                                                </Step>
                                            );
                                        })}
                                    </Stepper>
                                    <div>
                                        <Button
                                            disabled={
                                                activeStep <= 0 ||
                                                activeStep > 3
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    activeStep: activeStep - 1,
                                                });
                                            }}
                                        >
                                            Back
                                        </Button>
                                        <Button
                                            disabled={
                                                this.state.formName.trim() ===
                                                ""
                                            }
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (activeStep === 3) {
                                                    this.props.submitSSWP(
                                                        this.state.formName,
                                                        this.state.structure,
                                                        this.state.formUID,
                                                        this.state
                                                            .templateType ===
                                                            "edit"
                                                            ? true
                                                            : false
                                                    );
                                                    this.setState({
                                                        structure: structure,
                                                        editingForm: false,
                                                        editFormIndex: -1,
                                                        submitSuccess: true,
                                                    });
                                                }
                                                if (activeStep > 3)
                                                    this.setState({
                                                        activeStep: 0,
                                                        formName: "",
                                                    });
                                                if (
                                                    activeStep <
                                                    stepLabels.length
                                                )
                                                    this.setState({
                                                        activeStep:
                                                            activeStep + 1,
                                                    });
                                            }}
                                        >
                                            {activeStep === 3
                                                ? "Submit"
                                                : activeStep > 3
                                                ? "Create New Template"
                                                : "Next"}
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid item xl={10} lg={10} md={10} sm={12}>
                                    {this.getStepContent(activeStep)}
                                </Grid>
                            </Grid>
                            <InfoModal
                                open={this.state.infoModal}
                                info={this.state.infoModalTextImg}
                            />
                        </StyledViewContainer>
                    </StyledContent>
                </>
                <Modal isOpen={this.state.warningModal}>
                    <ModalHeader>Warning!!!</ModalHeader>
                    <ModalBody>
                        <b>This SSWP name already exists</b>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    warningModal: false,
                                    formName: "",
                                });
                            }}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.deleteModal ? true : false}>
                    <ModalHeader>Delete An SSWP Template</ModalHeader>
                    <ModalBody>
                        <b>
                            Are you sure you want to delete SSWP Template with
                            the name:{" "}
                            {this.props.sswpConfigs && this.state.deleteModal
                                ? this.props.sswpConfigs[this.state.deleteModal]
                                      .template_name
                                : "N/A"}
                        </b>
                        <br />
                        <b style={{ color: "red" }}>
                            NOTE: If you delete this Template, it will not
                            effect any reports created with this template. You
                            will not be able to make any more reports using this
                            template.{" "}
                        </b>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    deleteModal: false,
                                });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                let id = this.state.deleteModal;
                                this.props.deleteSSWPConfig(id);
                                this.setState({
                                    deleteModal: false,
                                });
                            }}
                        >
                            Delete
                        </Button>
                    </ModalFooter>
                </Modal>
            </StyledCard>
        );
    }
}

export default hot(module)(
    connect(
        (store) => {
            return {
                sswpConfigs: selectSSWPConfigs(store),
                requesting: getRequesting(store),
                canUpdate: canUpdate(store),
                canCreate: canCreate(store),
                canDelete: canDelete(store),
            };
        },
        { submitSSWP, getSSWPMasterConfigs, deleteSSWPConfig }
    )(MasterSSWPFormCreate)
);
